import { atom } from 'jotai';
import { PreferenceKey } from '../../../../data-models/preferences-v3.data-model';
import { createCompanyOrDefaultPrefAtoms } from '../../../../util/preferences-service-v3';
import { DropTarget, TearsheetV2Layout } from './types';
import { defaultLayout } from './utils/defaultLayout';

export const selectedCompanyIdAtom = atom<number | null>(null);

const tearsheetPref = createCompanyOrDefaultPrefAtoms<TearsheetV2Layout>({
  preferenceKey: PreferenceKey.tearSheetV1Layout,
  defaultValue: defaultLayout,
  selectedCompanyIdAtom,
});

export const tearsheetDefaultLayout = tearsheetPref.orgDefaultAtom;
export const tearsheetV1LayoutForCompanyAtom = tearsheetPref.companyOverrideAtom;
export const activeLayoutAtom = tearsheetPref.activeAtom;

// Atom to track the currently dragged panel type (for visual feedback)
export const draggingPanelAtom = atom<string | null>(null);

// Atom to track the active drop target during drag
export const activeDropTargetAtom = atom<DropTarget | null>(null);
